import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Link from 'components/common/Link';

import IconUserAdd from 'components/icons/IconUserAdd';
import IconFolder from 'components/icons/IconFolder';
import IconNotepad from 'components/icons/IconNotepad';
import Tooltip from 'components/common/Tooltip';
import OrderInformationSectionTitle from './OrderInformationSectionTitle';

const styles = theme => ({
  body: {
    marginTop: 24,
    padding: 15,
    border: `1px solid ${theme.palette.primary.A100}`,
    borderRadius: 5,
    [theme.breakpoints.down('sm')]: {
      marginTop: 8,
    },
  },
  bodyError: {
    borderColor: theme.palette.validation[500],
  },
  link: {
    paddingTop: 7,
    paddingBottom: 7,
  },
  iconUserAdd: {
    width: 22,
    height: 16,
    marginBottom: -2,
    marginRight: 10,
    color: theme.palette.primary.A400,
  },
  iconFolder: {
    width: 20,
    height: 16,
    marginBottom: -2,
    marginRight: 10,
    color: theme.palette.primary.A400,
  },
  iconNotepad: {
    width: 18,
    height: 22,
    marginBottom: -4,
    marginRight: 10,
    color: theme.palette.primary.A400,
  },
  typography: {
    display: 'inline-block',
    marginRight: 5,
  },
});

const OrderInformationSectionEmpty = ({
  input,
  meta: { error, touched },
  title,
  text,
  onAddButtonClick,
  type,
  addButtonOwns,
  disabled,
  classes,
}) => (
  <div>
    {title &&
      <OrderInformationSectionTitle title={title} />
    }
    <div
      className={classNames(classes.body, {
        [classes.bodyError]: error && touched,
      })}
      name={input.name}
    >
      <Tooltip
        content={
          error ? (
            <Typography variant="subheading" color="secondary">
              {error}
            </Typography>
          ) : ' '
        }
        placement="left"
        color="white"
        disabled={!(error && touched)}
      >
        {type === 'vitals' &&
          <IconFolder className={classes.iconFolder} />
        }
        {type === 'diagnoses' &&
          <IconNotepad className={classes.iconNotepad} />
        }
        {(type === 'prescriber'
          || type === 'salesRepresentative'
          || type === 'referralSource') &&
          <IconUserAdd className={classes.iconUserAdd} />
        }
        <Typography
          className={classes.typography}
          color="secondary"
        >
          {text}
        </Typography>
        <Link
          className={classes.link}
          color="primary"
          bold
          size="md"
          aria-label="More"
          aria-owns={addButtonOwns}
          aria-haspopup="true"
          disabled={disabled}
          {...onAddButtonClick ? { onClick: onAddButtonClick } : {}}
        >
          Add
        </Link>
      </Tooltip>
    </div>
  </div>
);

OrderInformationSectionEmpty.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string.isRequired,
  onAddButtonClick: PropTypes.func,
  type: PropTypes.oneOf([
    'vitals', 'prescriber', 'diagnoses', 'referralSource', 'salesRepresentative',
  ]).isRequired,
  addButtonOwns: PropTypes.string,
  input: PropTypes.shape({
    name: PropTypes.string,
  }),
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool,
  }),
  disabled: PropTypes.bool,
  classes: PropTypes.shape({
    body: PropTypes.string.isRequired,
    bodyError: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    iconUserAdd: PropTypes.string.isRequired,
    iconFolder: PropTypes.string.isRequired,
    iconNotepad: PropTypes.string.isRequired,
    typography: PropTypes.string.isRequired,
  }).isRequired,
};

OrderInformationSectionEmpty.defaultProps = {
  title: null,
  onAddButtonClick: null,
  addButtonOwns: null,
  meta: {},
  input: {},
  disabled: false,
};

export default withStyles(styles)(OrderInformationSectionEmpty);



// WEBPACK FOOTER //
// ./src/components/workflow/OrderInformation/OrderInformationSectionEmpty.js